import { EnrichedComponentCategory } from '../domain/category/CategoryOperationDomains';

class PageUtil {
  public static calculateDefaultCategory(): EnrichedComponentCategory {
    return {
      id: 'Main',
      name: 'Main',
      path: ['Main'],
      components: [],
      categories: [],
      collaborators: [],
    };
  }
}
export default PageUtil;
